export default "__VITE_ASSET__8ylsfFcT__"